import { Product } from '@@types'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router'

import { useCartStore } from '@entities/Cart'
import { useFetchSimilarProducts } from '@entities/Product'

import { useModalStore } from '@features/modal'
import { useAddressStore } from '@features/shipping-methods'

import { ProductCarousel } from '@widgets/product-carousel'

import { URL_PAGE_CATALOG, URL_PAGE_CATALOG_1ST_LVL } from '@shared/contants'
import { useEmitter } from '@shared/lib/emitter'


interface ProductsSimilarProps {
  product: Product;
  title?: string;
}

export default function ProductsSimilar (props: ProductsSimilarProps) {
  const { t: tp } = useTranslation('product')
  const { product, title } = props
  const { shopId } = useAddressStore()
  const { data, loading } = useFetchSimilarProducts({
    shopId,
    productId: product.id,
  })
  const { removeProduct } = useCartStore()
  const { modals, closeModal } = useModalStore()
  const { emitter } = useEmitter()

  const SIMILAR_PRODUCTS_MODAL_ACTIVE = useMemo(() => {
    return !!modals.get('productsSimilar')?.isOpen
  }, [ modals ])

  emitter.on('addCartProduct', () => {
    if (SIMILAR_PRODUCTS_MODAL_ACTIVE) {
      removeProduct(product.id)
    }
  })

  // Получаем slug категории товара (берем первую категорию)
  const categoryLink = useMemo(() => {
    const category = product?.categories?.[0]
    return category?.slug ? generatePath(URL_PAGE_CATALOG_1ST_LVL, { categorySlug: category.slug }) : URL_PAGE_CATALOG
  }, [ product ])

  const handleLinkClick = () => {
    if (SIMILAR_PRODUCTS_MODAL_ACTIVE) {
      closeModal('productsSimilar')
    }
  }

  return (
    <ProductCarousel
      link={categoryLink}
      title={title ?? tp('similar_products')}
      products={data?.similarProducts as never[]}
      loading={loading}
      onLinkClick={handleLinkClick}
    />
  )
}
